import React from 'react';
import PropTypes from 'prop-types';
import './accordion.scss';
import Icon from '../../mweb/Icon/Icon';

const Accordion = props => {
  const { title, content, color, blackIcon } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <div className="accordion" style={{ color: color }}>
      <div className="accordion--header" onClick={() => setOpen(!open)}>
        <div className="accordion--header--title">{title}</div>
        {blackIcon ? (
          <Icon
            class={`accordion--header--caret ${
              open
                ? 'icon-common-black-arrow-right arrow-up'
                : 'icon-common-black-arrow-right arrow-down'
            }`}
            size={10}
          />
        ) : (
          <Icon
            class={`accordion--header--caret ${
              open
                ? 'icon-common-white-arrow-right arrow-up'
                : 'icon-common-white-arrow-right arrow-down'
            }`}
            size={10}
          />
        )}
      </div>
      {open && <div className="accordion--body">{content}</div>}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
  blackIcon: PropTypes.bool.isRequired,
};

export default Accordion;
